<div id="site" class="d-flex align-items-center bg-auth border-top border-top-2 border-primary h-100">

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">

        <!-- Heading -->
        <h1 class="display-4 text-center mb-3">
          Passwort zurücksetzen
        </h1>

        <!-- Subheading -->
        <p class="text-muted text-center mb-5">
          Sie erhalten ein neues Passwort per E-Mail.
        </p>

        <!-- Form -->
        <form>

          <!-- Email address -->
          <div class="form-group">

            <!-- Label -->
            <div class="row">
              <div class="col">

                <!-- Label -->
                <label>E-Mail</label>

              </div>
              <div class="col-auto">

                <!-- Help text -->
                <a routerLink="/login" class="form-text small text-muted">
                  Sie kennen Ihr Passwort?
                </a>

              </div>
            </div> <!-- / .row -->

            <!-- Input -->
            <input type="email" name="eMail" [(ngModel)]="eMail" class="form-control" placeholder="name@address.com">

          </div>

          <div class="alert alert-danger" *ngIf="error">
            {{error}}
          </div>

          <div class="alert alert-success" *ngIf="success">
              {{success}}
            </div>

          <!-- Submit -->
          <button class="btn btn-lg btn-block btn-primary mb-3" (click)="submit()" [disabled]="success">
            Passwort zurücksetzen
          </button>


          <!-- Link -->
          <!--
          <div class="text-center">
            <small class="text-muted text-center">
              Don't have an account yet? <a href="sign-up.html">Sign up</a>.
            </small>
          </div
        -->

        </form>

      </div>
    </div> <!-- / .row -->
  </div>

</div>